<template>

  <div id="app_content" class="reserved">

    <div class="section-top djcaid-fccc">
      <div class="logo">
        <div class="w-image">
          <img :src="url('/media/icons/svg/logo4-belt.svg')" alt="Logo 4-Belt">
        </div>
      </div>
      <h1>Ensure Your Power</h1>
    </div>

    <div class="section-flex-collection" v-if="categorie">
      <div class="element" v-for="(c, i) in categorie">
        <div class="texture">
          <div class="w-content">
            <div class="w-image">
              <!--              <img :src="url('/media/icons/svg/family/black/'+microfamiglia.codice.toLowerCase()+'.svg')"-->
              <!--                   alt="Icona microfamiglia articoli">-->
            </div>
            <div class="w-text">
              <h3 class="ttl">{{ c.category.descrizione }}</h3>

              <!-- todo action al carrello -> usare slug per identificare articolo/colore             -->
              <a class="link-ret green" :href="url('/b2b/microfamily-article/'+c.category.codice)">{{ trans.get("b2b.explore") }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  components: {
    breadcrumb
  },

  data: function () {

    return {


      loading: false,
      isMounted: false,
      category: null,
      family: null,
      currentBreadcrumb: [],
      categorie: null,

      category_1: [
        this.url('/media/icons/svg/cat-1/01-round-belt-black.svg'),
        this.url('/media/icons/svg/cat-1/02-tubular-belt.svg'),
        this.url('/media/icons/svg/cat-1/03-v-belt.svg'),
        this.url('/media/icons/svg/cat-1/04-v-belt-+.svg'),
        this.url('/media/icons/svg/cat-1/05-twin-belt.svg'),
        this.url('/media/icons/svg/cat-1/06-crest-belt.svg'),
      ],

    }

  },

  created: function () {


  },

  mounted: function () {

    this.loadFamily();

  },

  computed: {},

  methods: {

    loadFamily: function () {
      var vue = this;
      vue.loading = true;
      let pathname = window.location.pathname.split('/');
      let cod_family = pathname[pathname.length - 1];

      axios({
        method: 'get',
        url: window.location.origin + '/data/get-family',
        params: {
          cod: cod_family,
          type: 'category',
        }
      })
          .then(res => {
            this.category = res.data.family
            //this.categorie = [...new Set(this.category.map(item => item.category.descrizione))]
            this.categorie = [...new Map(this.category.map(item => [item.category.codice, item])).values()]
           // console.log(this.categorie)
            this.currentBreadcrumb.push(this.categorie[0].macrofamily.descrizione)
            this.currentBreadcrumb.push(this.categorie[0].family.descrizione)
            this.currentBreadcrumb.push(this.categorie[0].microfamily.descrizione)


            // this.currentBreadcrumb.push(this.category.macrofamily.descrizione)
            // this.currentBreadcrumb.push(this.category.family.descrizione)
            vue.isMounted = true;
          })
          .catch(err => {

            vue.loading = false;

            vue.$store.commit('add_message', {
              type: 'error',
              message: err.response.data.message
            })

          })
    },

  }

}
</script>

<style scoped>
.djcaid-fccc {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.section-top {
  height: 50vh;
  background-color: var(--black);
  color: white;
}

.section-top .w-image {
  width: 308px;
  height: auto;
}

.section-top .w-image img {
  display: block;
  width: inherit;
  height: auto;
}

.section-top h1 {
  /* font-weight: lighter; */
  font-size: 40px;
  margin-bottom: 0;
}

.section-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--background-gray-2);
  margin: 1em 0;
}

.section-flex-collection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0.5em 0 0 0;
}

.section-flex-collection .element {
  width: 50%;
}

.section-flex-collection .element .texture {
  padding: 4em 0;
  width: 100%;
  height: auto;
  background-color: var(--background-gray-2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-flex-collection .element .texture .w-content {
  width: 50%;
}

/* Pari */
.section-flex-collection .element:nth-child(2n) {
  padding: 5px 0px 5px 5px;
}

.section-flex-collection .element:nth-child(2n) .texture {
  /* justify-content: flex-start; */
}

.section-flex-collection .element:nth-child(2n) .texture .w-content {
  /* margin-left: 20%; */
}

/* Dispari */
.section-flex-collection .element:nth-child(2n+1) {
  padding: 5px 5px 5px 0px;
}

.section-flex-collection .element:nth-child(2n+1) .texture {
  /* justify-content: flex-end; */
}

.section-flex-collection .element:nth-child(2n+1) .texture .w-content {
  /* margin-right: 20%; */
}

.section-flex-collection .w-image {
  width: 49px;
}

.section-flex-collection .w-image img {
  width: 100%;
  display: block;
}
</style>
